import * as React from "react";
import { IAllocationDimension } from "helpers/allocation-dimension";
import { MultiSelect } from "components/common/multi-select";

interface IProps {
    merchantAllocationDimension: IAllocationDimension;
    onChange: (selectedAllocationDimensionValuesIds) => void;
}

const ValuesSelect: React.FC<IProps> = React.memo(function ValueSelectFC(props: IProps) {
    const { merchantAllocationDimension, onChange } = props;

    const activeAllocationDimensionValues = React.useMemo(() => {
        return merchantAllocationDimension.dimension_values.filter((allocationDimensionValue) => {
            return allocationDimensionValue.active;
        });
    }, [merchantAllocationDimension]);

    const selectOptions = React.useMemo(() => {
        return activeAllocationDimensionValues.map((dimensionValue) => ({
            label: dimensionValue.name,
            value: dimensionValue.id,
            included: dimensionValue.included,
        }));
    }, [activeAllocationDimensionValues]);
    const defaultSelectValues = React.useMemo(() => {
        // default to be checked if item.included is true.
        const filteredSelectOptions = selectOptions.filter((item) => item.included);
        return filteredSelectOptions.map((option) => option.value);
    }, [selectOptions]);

    const handleOnChange = React.useCallback(
        (selectedValues) => {
            onChange(selectedValues);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [merchantAllocationDimension, onChange]
    );
    return (
        <MultiSelect
            label={merchantAllocationDimension.name}
            options={selectOptions}
            defaultValues={defaultSelectValues}
            onChange={handleOnChange}
        />
    );
});

export { ValuesSelect };
